<template>
  <div>
    <input class="title" :disabled="disabled" type="text" v-model="valueCtitle" placeholder="请输入文档标题（劳务合同书）">
    <div v-html="value"></div>
    <textarea
      :disabled="disabled"
      v-model="valueC1"
      placeholder="请输入内容"
    ></textarea>
    <div v-html="valueFooter"></div>
    <table style="width: 100%">
      <caption>
        模板标题、合同内容 均可自定义模板内容
      </caption>
    </table>
  </div>
</template>
    
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valueCtitle: "",
      valueC1: "",
      value: `<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.1 plus MathML 2.0//EN" "http://www.w3.org/Math/DTD/mathml2/xhtml-math11-f.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" lang="en-US">
<!--This file was converted to xhtml by LibreOffice - see https://cgit.freedesktop.org/libreoffice/core/tree/filter/source/xslt for the code.-->

<head profile="http://dublincore.org/documents/dcmi-terms/">
<meta http-equiv="Content-Type" content="application/xhtml+xml; charset=utf-8"/>
<title xml:lang="en-US&#10;">- no title specified</title>
<meta name="DCTERMS.title" content="" xml:lang="en-US&#10;"/>

<meta name="DCTERMS.language" content="en-US&#10;" scheme="DCTERMS.RFC4646"/>
<meta name="DCTERMS.source" content="http://xml.openoffice.org/odf2xhtml"/>
<meta name="DCTERMS.creator" content="Administrator"/>
<meta name="DCTERMS.issued" content="2023-04-14T08:09:00" scheme="DCTERMS.W3CDTF"/>
<meta name="DCTERMS.contributor" content="可爱又迷人的反派角色"/>
<meta name="DCTERMS.modified" content="2023-09-09T05:00:17" scheme="DCTERMS.W3CDTF"/>
<meta name="DCTERMS.provenance" content="&#10;" xml:lang="en-US&#10;"/>


<meta name="xsl:vendor" content="libxslt"/>

<style>
    table { border-collapse:collapse; border-spacing:0; empty-cells:show }
    td, th { vertical-align:top; font-size:12pt;}
    h1, h2, h3, h4, h5, h6 { clear:both;}
    ol, ul { margin:0; padding:0;}
    li { list-style: none; margin:0; padding:0;}
    span.footnodeNumber { padding-right:1em; }
    span.annotation_style_by_filter { font-size:95%; font-family:Arial; background-color:#fff000;  margin:0; border:0; padding:0;  }
    span.heading_numbering { margin-right: 0.8rem; }* { margin:0;}
    .P1 { font-size:12pt; margin-bottom:0in; margin-left:0.5in; margin-right:0in; margin-top:0.1382in; text-align:justify ! important; text-indent:0in; writing-mode:horizontal-tb; direction:ltr; line-height:0.222in; color:#000000; }
    .P10 { font-size:12pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; writing-mode:horizontal-tb; direction:ltr; line-height:0.222in; color:#000000; letter-spacing:-0.0075in; }
    .P11 { font-size:12pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; writing-mode:horizontal-tb; direction:ltr; line-height:0.222in; color:#000000; }
    .P12 { font-size:12pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; writing-mode:horizontal-tb; direction:ltr; line-height:0.3055in; color:#000000; }
    .P13 { font-size:12pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; writing-mode:horizontal-tb; direction:ltr; line-height:0.1665in; color:#000000; }
    .P14 { font-size:12pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; writing-mode:horizontal-tb; direction:ltr; line-height:0.3055in; color:#000000; }
    .P15 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.1665in; }
    .P16 { font-size:10.5pt; margin-bottom:0in; margin-top:0.1382in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.1665in; }
    .P17 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; margin-left:0in; margin-right:0in; line-height:0.25in; text-indent:0.25in; }
    .P18 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.25in; }
    .P19 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; margin-left:0in; margin-right:0in; line-height:0.25in; text-indent:0.1665in; }
    .P2 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; }
    .P20 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.3055in; }
    .P21 { font-size:12pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:宋体; writing-mode:horizontal-tb; direction:ltr; margin-left:0in; margin-right:0in; text-indent:0.5835in; }
    .P3 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:center ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; }
    .P4 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; margin-left:4.0835in; margin-right:0in; text-indent:0.5835in; }
    .P5 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; margin-left:0in; margin-right:0in; text-indent:0.5835in; }
    .P6 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.222in; }
    .P7 { font-size:10.5pt; margin-bottom:0in; margin-top:0.1382in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.222in; }
    .P8 { font-size:10.5pt; margin-bottom:0in; margin-top:0.1402in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.222in; }
    .P9 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.222in; }
    .Standard { font-size:10.5pt; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; margin-top:0in; margin-bottom:0in; text-align:justify ! important; }
    .T10 { color:#000000; font-size:12pt; }
    .T11 { color:#000000; font-size:12pt; }
    .T12 { color:#000000; font-size:12pt; letter-spacing:0.0008in; }
    .T13 { color:#000000; font-size:12pt; letter-spacing:-0.0035in; }
    .T14 { color:#000000; font-size:12pt; letter-spacing:-0.0016in; }
    .T15 { color:#000000; font-size:12pt; letter-spacing:0.0016in; }
    .T16 { color:#000000; font-size:12pt; }
    .T17 { color:#000000; font-size:20pt; letter-spacing:0.0709in; }
    .T18 { color:#000000; font-size:20pt; letter-spacing:0.0717in; }
    .T19 { color:#000000; font-size:12pt; }
    .T2 { color:#000000; font-size:20pt; }
    .T20 { font-family:宋体; font-size:12pt; }
    .T21 { font-family:宋体; font-size:12pt; }
    .T22 { font-family:宋体; font-size:12pt; text-decoration:underline; }
    .T23 { font-family:宋体; font-size:12pt; }
    .T24 { font-family:宋体; font-size:12pt; }
    .T3 { color:#000000; font-size:12pt; letter-spacing:-0.0075in; }
    .T4 { color:#000000; font-size:12pt; letter-spacing:-0.0075in; text-decoration:underline; }
    .T5 { color:#000000; font-size:12pt; letter-spacing:-0.0075in; text-decoration:underline; }
    .T6 { color:#000000; font-size:12pt; letter-spacing:-0.0075in; }
    .T7 { color:#000000; font-size:12pt; letter-spacing:-0.0075in; }
    .T8 { color:#000000; font-size:12pt; text-decoration:underline; }
    .T9 { color:#000000; font-size:12pt; text-decoration:underline; }
    /* ODF styles with no properties representable as CSS:
    .dp1  { } */
</style>
</head>

<body dir="ltr" style="max-width:8.2681in;margin-top:1in; margin-bottom:1in; margin-left:1.25in; margin-right:1.25in; ">
<p class="P2"> </p>

<p class="P6"><span class="T3">甲方：</span><span class="T4">                                                                </span><span class="T3">   </span><span class="T3"/></p>
<p class="P10"> </p>
<p class="P6"><span class="T3">乙方：</span><span class="T4">  </span><span class="T5"></span><span class="T4">                                                               </span><span class="T6"></span><span class="T3">   身份证号：</span><span class="T6"></span><span class="T7"/></p>
<p class="P10"> </p>
<p class="P6"><span class="T3">住址：</span><span class="T4">  </span><span class="T5"></span><span class="T4">                                                              </span><span class="T3">    联系电话： </span><span class="T4"> </span><span class="T5"></span><span class="T4">                                </span><span class="T3"></span><span class="T4">                                                </span></p>
<p class="P11"> </p>



</html>
`,
      valueFooter: `<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.1 plus MathML 2.0//EN" "http://www.w3.org/Math/DTD/mathml2/xhtml-math11-f.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" lang="en-US">
<!--This file was converted to xhtml by LibreOffice - see https://cgit.freedesktop.org/libreoffice/core/tree/filter/source/xslt for the code.-->

<head profile="http://dublincore.org/documents/dcmi-terms/">
<meta http-equiv="Content-Type" content="application/xhtml+xml; charset=utf-8"/>
<title xml:lang="en-US&#10;">- no title specified</title>
<meta name="DCTERMS.title" content="" xml:lang="en-US&#10;"/>

<meta name="DCTERMS.language" content="en-US&#10;" scheme="DCTERMS.RFC4646"/>
<meta name="DCTERMS.source" content="http://xml.openoffice.org/odf2xhtml"/>
<meta name="DCTERMS.creator" content="Administrator"/>
<meta name="DCTERMS.issued" content="2023-04-14T08:09:00" scheme="DCTERMS.W3CDTF"/>
<meta name="DCTERMS.contributor" content="可爱又迷人的反派角色"/>
<meta name="DCTERMS.modified" content="2023-09-09T05:00:17" scheme="DCTERMS.W3CDTF"/>
<meta name="DCTERMS.provenance" content="&#10;" xml:lang="en-US&#10;"/>


<meta name="xsl:vendor" content="libxslt"/>

<style>
    table { border-collapse:collapse; border-spacing:0; empty-cells:show }
    td, th { vertical-align:top; font-size:12pt;}
    h1, h2, h3, h4, h5, h6 { clear:both;}
    ol, ul { margin:0; padding:0;}
    li { list-style: none; margin:0; padding:0;}
    span.footnodeNumber { padding-right:1em; }
    span.annotation_style_by_filter { font-size:95%; font-family:Arial; background-color:#fff000;  margin:0; border:0; padding:0;  }
    span.heading_numbering { margin-right: 0.8rem; }* { margin:0;}
    .P1 { font-size:12pt; margin-bottom:0in; margin-left:0.5in; margin-right:0in; margin-top:0.1382in; text-align:justify ! important; text-indent:0in; writing-mode:horizontal-tb; direction:ltr; line-height:0.222in; color:#000000; }
    .P10 { font-size:12pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; writing-mode:horizontal-tb; direction:ltr; line-height:0.222in; color:#000000; letter-spacing:-0.0075in; }
    .P11 { font-size:12pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; writing-mode:horizontal-tb; direction:ltr; line-height:0.222in; color:#000000; }
    .P12 { font-size:12pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; writing-mode:horizontal-tb; direction:ltr; line-height:0.3055in; color:#000000; }
    .P13 { font-size:12pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; writing-mode:horizontal-tb; direction:ltr; line-height:0.1665in; color:#000000; }
    .P14 { font-size:12pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; writing-mode:horizontal-tb; direction:ltr; line-height:0.3055in; color:#000000; }
    .P15 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.1665in; }
    .P16 { font-size:10.5pt; margin-bottom:0in; margin-top:0.1382in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.1665in; }
    .P17 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; margin-left:0in; margin-right:0in; line-height:0.25in; text-indent:0.25in; }
    .P18 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.25in; }
    .P19 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; margin-left:0in; margin-right:0in; line-height:0.25in; text-indent:0.1665in; }
    .P2 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; }
    .P20 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.3055in; }
    .P21 { font-size:12pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:宋体; writing-mode:horizontal-tb; direction:ltr; margin-left:0in; margin-right:0in; text-indent:0.5835in; }
    .P3 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:center ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; }
    .P4 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; margin-left:4.0835in; margin-right:0in; text-indent:0.5835in; }
    .P5 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; margin-left:0in; margin-right:0in; text-indent:0.5835in; }
    .P6 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.222in; }
    .P7 { font-size:10.5pt; margin-bottom:0in; margin-top:0.1382in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.222in; }
    .P8 { font-size:10.5pt; margin-bottom:0in; margin-top:0.1402in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.222in; }
    .P9 { font-size:10.5pt; margin-bottom:0in; margin-top:0in; text-align:justify ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; line-height:0.222in; }
    .Standard { font-size:10.5pt; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; margin-top:0in; margin-bottom:0in; text-align:justify ! important; }
    .T10 { color:#000000; font-size:12pt; }
    .T11 { color:#000000; font-size:12pt; }
    .T12 { color:#000000; font-size:12pt; letter-spacing:0.0008in; }
    .T13 { color:#000000; font-size:12pt; letter-spacing:-0.0035in; }
    .T14 { color:#000000; font-size:12pt; letter-spacing:-0.0016in; }
    .T15 { color:#000000; font-size:12pt; letter-spacing:0.0016in; }
    .T16 { color:#000000; font-size:12pt; }
    .T17 { color:#000000; font-size:20pt; letter-spacing:0.0709in; }
    .T18 { color:#000000; font-size:20pt; letter-spacing:0.0717in; }
    .T19 { color:#000000; font-size:12pt; }
    .T2 { color:#000000; font-size:20pt; }
    .T20 { font-family:宋体; font-size:12pt; }
    .T21 { font-family:宋体; font-size:12pt; }
    .T22 { font-family:宋体; font-size:12pt; text-decoration:underline; }
    .T23 { font-family:宋体; font-size:12pt; }
    .T24 { font-family:宋体; font-size:12pt; }
    .T3 { color:#000000; font-size:12pt; letter-spacing:-0.0075in; }
    .T4 { color:#000000; font-size:12pt; letter-spacing:-0.0075in; text-decoration:underline; }
    .T5 { color:#000000; font-size:12pt; letter-spacing:-0.0075in; text-decoration:underline; }
    .T6 { color:#000000; font-size:12pt; letter-spacing:-0.0075in; }
    .T7 { color:#000000; font-size:12pt; letter-spacing:-0.0075in; }
    .T8 { color:#000000; font-size:12pt; text-decoration:underline; }
    .T9 { color:#000000; font-size:12pt; text-decoration:underline; }
    /* ODF styles with no properties representable as CSS:
    .dp1  { } */
</style>
</head>

<body dir="ltr" style="max-width:8.2681in;margin-top:1in; margin-bottom:1in; margin-left:1.25in; margin-right:1.25in; ">
<p class="P12"> </p>
<p class="P20"><span class="T10">        甲方：                                                                                               </span><span class="T16">乙</span><span class="T10">方：</span><span class="T16"></span><span class="T16"/></p>

<p class="P14"></p>

<p class="P4"><span class="T23"></span><span class="T24"/></p>
<p class="P21"> </p><p class="P21"> </p>
<p class="P5"><span class="T20">年    月    日                   年    月   日</span><span class="T21"/></p>
<p class="Standard"> </p></body>

</html>`,
    };
  },
};
</script>
<style scoped>
.title{
  outline: none;
  border: none;
  background: none;
  width: 100%;
  font-size: 30px;
  text-align: center;
  color: #000;
}
textarea {
  border: none;
  width: 100%;
  min-height: 500px;
  outline: none;
  font-size: 16px;
  /* margin-top: 10px; */
}
</style>